// Module
var code = `<div class="telephone-input">
  <input class="telephone-input__input"
         type="text"
         minlength="7"
         maxlength="14"
         ng-class="{'nx-invalid': !\$ctrl.isNumberValid()}"
         ng-disabled="\$ctrl.disabled"
         ng-required="\$ctrl.required"
         placeholder="Example: +639995555444"
         ui-options="{{\$ctrl.getUiOptions()}}"
         title="only leading '+' and numbers are allowed"
         ng-model="\$ctrl.telephoneNumber"
         ng-change="\$ctrl.numberChanged()"/>
  <help class="telephone-input__label" title="Phone number must match E.164 format. Example: +639995555444"></help>
</div>
<validator condition="\$ctrl.isNumberValid()"></validator>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/telephone/telephone.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;